
import React, { useEffect, useState, useCallback } from "react";
import { useIndexResourceState, Card, Filters, IndexTable, Page, Pagination } from '@shopify/polaris';
import { TitleBar } from "@shopify/app-bridge-react";

import instance from "../api";
import Footer from '../Components/footer/footer';
import { connect } from "react-redux";

function Order(props) {
    const editableColumn = { textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' };
    const resourceName = {
        singular: 'Order',
        plural: 'Orders',
    };
    const [queryValue, setQueryValue] = useState('');
    const [orderList, setOrderList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [nextCursor, setNextCursor] = useState('');
    const { selectedResources, allResourcesSelected, handleSelectionChange } = useIndexResourceState(orderList);
    
    const handleQueryKeyChange = useCallback((value) => {
        setQueryValue(value);
    }, []);
   
    const handleQueryValueRemove = useCallback(() => {
        setQueryValue('')
        fetchOrderData('');
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClearAll = useCallback(() => {
        handleQueryValueRemove();
    }, [handleQueryValueRemove]);

    const fetchOrderData = async (query, cb) => {
        setIsLoading(true);
        query = query ? query : '';
        instance.get(`api/shopify/orders/get?nextCursor=${nextCursor}&filter=${query}`)
            .then(res => res.data)
            .then(response => {
                let orders = response?.nodes?.length > 0 ? response.nodes : [];
                orders = orders.map(order => { return { ...order, order_number: getProductId(order.id)  } });
                setOrderList(orders);
                setNextCursor(response?.pageInfo?.endCursor ? response.pageInfo.endCursor : '');
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false)
            });
    };

    const filters = [];

    const appliedFilters = !isEmpty('')
        ? []
        : [];

    const rowMarkup = orderList.map(
        ({ id, order_number, currentTotalPriceSet, displayFinancialStatus, lineItems, createdAt }, index) => (

            <IndexTable.Row
                id={order_number}
                key={order_number}
                selected={selectedResources.includes(order_number)}
                position={index}>
                <IndexTable.Cell> <span onClick={() => openOrderPage(order_number)} style={editableColumn}>#{order_number} </span></IndexTable.Cell>
                <IndexTable.Cell>{formatDate(createdAt)}</IndexTable.Cell>
                <IndexTable.Cell>{linkProduct(lineItems)}</IndexTable.Cell>
                <IndexTable.Cell>{currentTotalPriceSet?.shopMoney?.currencyCode}</IndexTable.Cell>
                <IndexTable.Cell>{currentTotalPriceSet?.shopMoney?.amount}</IndexTable.Cell>
                <IndexTable.Cell> <span style={{ textTransform: 'capitalize' }}>{displayFinancialStatus}</span></IndexTable.Cell>
            </IndexTable.Row>
        ),
    );

    function linkToProductItem(id) {
        window.open('shopify://admin/products/' + encodeURIComponent(id), '_top');
    }

    function openOrderPage(id) {
        window.open('shopify://admin/orders/' + encodeURIComponent(id), '_top');
    }

    useEffect(() => {
        fetchOrderData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Page fullWidth title="Orders">
            <TitleBar title="Orders" />
            <Card>
                <div style={{ padding: '16px', display: 'flex' }}>
                    <div style={{ flex: 1 }}>
                        <Filters
                            queryValue={queryValue}
                            filters={filters}
                            appliedFilters={appliedFilters}
                            onQueryChange={handleQueryKeyChange}
                            onQueryClear={handleQueryValueRemove}
                            onClearAll={handleClearAll}
                        />
                    </div>
                </div>
                <IndexTable
                    resourceName={resourceName}
                    itemCount={orderList.length}
                    selectedItemsCount={
                        allResourcesSelected ? 'All' : selectedResources.length
                    }
                    onSelectionChange={handleSelectionChange}
                    loading={isLoading}
                    headings={[
                        { title: 'Order No.' },
                        { title: 'Order Date' },
                        { title: 'Product Name' },
                        { title: 'Currency' },
                        { title: 'Total' },
                        { title: 'Status' },
                    ]}
                    selectable={false}>
                    {rowMarkup}
                </IndexTable>
            </Card>

            <div style={{ display: 'grid', placeContent: 'center', marginTop: '10px' }}>
                {
                    (orderList?.length > 0 && nextCursor) ?
                        <Pagination
                            hasNext
                            onNext={() => {
                                setIsLoading(true);
                                instance.get(`api/shopify/orders/get?nextCursor=${nextCursor}&filter=${queryValue}`)
                                    .then(res => res.data)
                                    .then(response => {
                                        let orders = response?.nodes?.length > 0 ? response.nodes : [];
                                        orders = orders.map(order => { return { ...order, order_number: getProductId(order.id) } });
                                        setOrderList([...orderList, ...orders]);
                                        setNextCursor(response?.pageInfo?.endCursor ? response.pageInfo.endCursor : '');
                                        setIsLoading(false);
                                    }, error => {
                                        setIsLoading(false);
                                    });
                            }}
                        />
                        : ""
                }
            </div>
            <Footer />
        </Page>
    );

    function isEmpty(value) {
        if (Array.isArray(value)) {
            return value.length === 0;
        } else {
            return value === '' || value == null;
        }
    }

    function linkProduct(lineItems) {
        if (lineItems?.nodes?.length > 0) {
            return <span style={{ cursor: "pointer", textDecoration: "underline", maxWidth: "330px" }} onClick={() => linkToProductItem(getProductId(lineItems.nodes[0]?.product?.id))}>{lineItems.nodes[0]?.name}</span>
        }
    }

    function formatDate(date) {
        if (!date) return "";
        return new Date(date).toLocaleString();
    }

    function getProductId(id){
        return id?.split("/")?.pop()
    }
}

const mapStateToProps = state => {
    return { appConfig: state.appConfig };
};

export default connect(mapStateToProps)(Order);